import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {TranslateModule} from "@ngx-translate/core";
import {BootstrappingComponent} from "../../components/bootstrapping/bootstrapping.component";
import {NgxIntlTelInputModule} from "ngx-intl-tel-input";
import {UiSwitchModule} from "ngx-toggle-switch";
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatCommonModule, MatNativeDateModule} from "@angular/material/core";
import {AnalyticsTotalSalesComponent} from "../../components/analytics/analytics-total-sales/analytics-total-sales.component";
import {AnalyticsSalesByCategoryComponent} from "../../components/analytics/analytics-sales-by-category/analytics-sales-by-category.component";
import {AnalyticsOrdersDailyCountComponent} from "../../components/analytics/analytics-orders-daily-count/analytics-orders-daily-count.component";
import {OrderHistoryComponent} from "../../components/order-history/order-history.component";
import {TopItemsSoldComponent} from "../../components/analytics/top-items-sold/top-items-sold.component";

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxIntlTelInputModule,
    UiSwitchModule,
    // -- Angular material -- //
    MatCommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule
    // -- Angular material -- //
  ],
  declarations: [
    BootstrappingComponent,
    AnalyticsTotalSalesComponent,
    AnalyticsSalesByCategoryComponent,
    AnalyticsOrdersDailyCountComponent,
    OrderHistoryComponent,
    TopItemsSoldComponent
  ],
  exports: [
    CommonModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxIntlTelInputModule,
    UiSwitchModule,
    // -- Angular material -- //
    MatCommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    // -- Angular material -- //
    // App components
    BootstrappingComponent,
    AnalyticsTotalSalesComponent,
    AnalyticsSalesByCategoryComponent,
    AnalyticsOrdersDailyCountComponent,
    OrderHistoryComponent,
    TopItemsSoldComponent
  ]
})
export class CommonSharedModule {}
